import { MapsTypes } from './types';
import { createRequestReducer } from '@fullstory/redux-util';

export const mapsReducer = createRequestReducer<{ [latLong: string]: string }, [string, string]>({
  mergeData: (data, [latLong, url]) => ({ ...data, [latLong]: url }),
})(MapsTypes.RequestImgUrl, MapsTypes.RequestImgUrlSuccess, MapsTypes.RequestImgUrlFailure);
